import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Menu } from 'semantic-ui-react';
import AvatarGroup from '@atlaskit/avatar-group';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import GConf from '../../AssetsM/generalConf';
import { useNavigate} from 'react-router-dom';

function LandingPage() {
    /* ############### Const #################*/
    const navigate = useNavigate();

    /* ############### UseEffect #################*/

    /* ############### Functions #################*/
    const GoToLink = (link) => {
        navigate(link)
    }
    
    /* ############### Card #################*/
    const TopCard = () =>{
        return(<>
                {/* <div className='card card-body shadow-sm text-end bg-system rounded-0 fixed-top'>
                    <div>
                        <Button size='mini'  className='rounded-pill'>  <span className='bi bi-person-circle me-1'></span> متابعة </Button>
                    </div>
                </div> */}
                <div className='mb-4'>
                        <Carousel showThumbs={false}  autoPlay  >
                            <div className='max-height-image'>
                                <img src="https://isigk.rnu.tn/useruploads/banners/516502711680_09_39_28.jpg" className='d-block'  width="100%" height="auto" />
                            </div>
                            
                            <div className='max-height-image'>
                                <img src="https://isigk.rnu.tn/useruploads/banners/316503711660_13_26_06.jpg" className='d-block'  width="100%" height="auto" />
                            </div>
                           
                            <div className='max-height-image'>
                                <img src="https://isigk.rnu.tn/useruploads/banners/216502712520_09_40_52.jpg" className='d-block'  width="100%" height="auto" />
                            </div>
                            {/* <div className='max-height-image'>
                                <img src="https://assets.ansl.tn/Images/ebo/4.jpg" className='d-block'  width="100%" height="auto" />
                            </div>
                            <div className='max-height-image'>
                                <img src="https://assets.ansl.tn/Images/ebo/5.jpg" className='d-block'  width="100%" height="auto"/>
                            </div>
                            <div className='max-height-image'>
                                <img src="https://assets.ansl.tn/Images/ebo/6.jpg" className='d-block'  width="100%" height="auto" />
                            </div> */}
                        </Carousel>

                    {/* <img src='https://assets.ansl.tn/Images/electro.jpg' className='img-responsive' width='100%' height='280px' /> */}
                </div>
            </>)
    }

    const BottomCard = () =>{
        return(<>
                <div className='card card-body shadow-sm bg-selected ' style={{borderRadius:'19px 70px 0 0'}}>
                    <div className='row'>
                        <div className="col-lg-6 col-12 text-left align-self-center text-white">
                            <div className="p-3">
                                <h6 className="this-font">
                                    Institut Supérieur d'Informatique et de Gestion de Kairouan
                                </h6>
                                <br />
                                <h6><span className="bi bi-telephone-fill"></span> +216 77 23 65 71 /+216 77 23 65 43 </h6>
                                <h6><span className="bi bi-geo-alt-fill"></span>   Avenue Khemais El Alouini - 3100 Kairouan - 3100 Kairouan </h6>
                                <a href="https://www.facebook.com/profile.php?id=100057108774675#" className="text-white"><span className="bi bi-facebook "></span> ISIG Kairouin  </a>
                            </div>   
                        </div>
                        {/* <div className="col-lg-6 col-12 align-self-center">
                            <div className="p-3">
                                <iframe width="100%" height="200" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" className="rounded" 
                                    src="https://www.openstreetmap.org/export/embed.html?bbox=9.097194671630861%2C36.16195863769561%2C9.145088195800783%2C36.18170539608309&amp;layer=mapnik&amp;marker=36.171832638869326%2C9.12114143371582" 
                                    >
                                </iframe>
                                <a className="btn btn-block btn-danger btn-sm" target="c_blank" href="https://www.google.com/maps/@36.177331,9.124139,602m/data=!3m1!1e3"> <span className="fa fa-map"></span> Voir Sur Google Map <span className="fa fa-angle-double-right float-right"></span></a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </>)
    }
 

    return ( <>
            <TopCard />
            <br /> 
            
            <div className='container'>

                <h1 className='text-center' style={{color:GConf.themeColor}}> SYSTEME DE GESTION DES ABSCENCE DES ETUDIANTS    </h1>
                <br />
                <div className="row p-1" >
                    <div className="col-12 col-lg-4 mb-4">
                        <div className='card card-body shadow mb-4 border-div text-center h-100' onClick={() => GoToLink('Admin')}>
                            <div className='text-center'><img src="https://cdn-icons-png.flaticon.com/512/1999/1999321.png"  width="150px" height="auto" /></div>
                            <h2 style={{color:'#ab18a4'}}> Espace Administration </h2>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 mb-4">
                        <div className='card card-body shadow mb-4 border-div text-center h-100' onClick={() => GoToLink('Proff')}>
                            <div className='text-center'><img src="https://cdn-icons-png.flaticon.com/512/1048/1048949.png"  width="150px" height="auto" /></div>
                            <h2 style={{color:'#cf084e'}}> Espace Enseignant </h2>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 mb-4">
                        <div className='card card-body shadow mb-4 border-div text-center h-100' onClick={() => GoToLink('Etudiant')}>
                            <div className='text-center'><img src="https://cdn-icons-png.flaticon.com/512/5850/5850276.png"  width="150px" height="auto" /></div>
                            <h2 style={{color:'#08cf6c'}}> Espace Etudiant </h2>
                        </div>
                    </div>
                     
                     
                     
                </div>     
            </div>
            <br />

            <BottomCard />
        </> );
}

export default LandingPage;